import {Component, OnInit} from '@angular/core';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {ReportCycle} from '../../../admin/models/report-cycle.interface';
import {Page} from '../../../shared/models/page.interface';
import {KfReportingService} from '../../services/kf-reporting.service';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';
import {ReportCycleSearch} from '../../../admin/models/report-cycle-search.interface';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-kf-report-cycles',
  templateUrl: './kf-report-cycles.component.html',
  styleUrls: ['./kf-report-cycles.component.scss']
})
export class KfReportCyclesComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;

  reportCyclesPage!: Page<ReportCycle>;
  private search!: ReportCycleSearch;
  private page: PageRequest = {page: 0, size: 100, sort: 'year', direction: 'desc'};

  constructor(private kfReportingService: KfReportingService,
              private messageService: MessageService,
              private router: Router,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.kfReportingService.getAll(this.page).subscribe(
      data => this.reportCyclesPage = data
    );

    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  searchReportCycles(event: ReportCycleSearch): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: this.buildQueryParams(event)});

    this.search = event;
    if (Object.keys(event).length === 0) {
      this.page = {page: 0, size: 100, sort: 'year', direction: 'desc'};
    }
    this.kfReportingService.searchReportCycles(event, this.page).subscribe(
      data => this.reportCyclesPage = data
    );
  }

  loadReportCycles(event: PageRequest): void {
    if (event.sort?.length === 0 || event.sort === undefined) {
      event.sort = 'year';
    }
    if ((event.direction?.length === 0 || event.direction === undefined) && event.sort === 'year') {
      event.direction = 'desc';
    }

    this.page = event;
    if (this.search) {
      this.kfReportingService.searchReportCycles(this.search, event).subscribe(
        data => this.reportCyclesPage = data
      );
    }
    this.kfReportingService.getAll(event).subscribe(
      data => this.reportCyclesPage = data
    );
  }

  printReportCycle(event: number): void {
    this.kfReportingService.printPdf(event)
      .subscribe(response => {
        const blob = new Blob([response.body], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }

  openReportCycle(event: ReportCycle): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        item: 'kf-reporting.open'
      },
      maxWidth: 600
    });
    dialogRef.componentInstance.confirmEvent.subscribe(() => {
      this.kfReportingService.openReportCycle(event).subscribe(
        () => {
          this.messageService.showMessage('The report cycle charts have been susccesfully opened', 'success');
          this.loadReportCycles(this.page);
        });
      dialogRef.close();
    });
  }

  private buildQueryParams(search: ReportCycleSearch): any {
    const queryParams = {};

    if (search.startYear) {
      Object.assign(queryParams, {startYear: search.startYear});
    }
    if (search.endYear) {
      Object.assign(queryParams, {endYear: search.endYear});
    }
    if (search.unuKeyName && search.unuKeyName !== '') {
      Object.assign(queryParams, {unuKeyName: search.unuKeyName});
    }
    if (search.kfCategoryName && search.kfCategoryName !== '') {
      Object.assign(queryParams, {kfCategoryName: search.kfCategoryName});
    }
    if (search.collectionStreamName && search.collectionStreamName !== '') {
      Object.assign(queryParams, {collectionStreamName: search.collectionStreamName});
    }
    if (search.launched) {
      Object.assign(queryParams, {launched: search.launched});
    }
    if (search.startLaunched && search.startLaunched !== '') {
      Object.assign(queryParams, {startLaunched: search.startLaunched});
    }
    if (search.endLaunched && search.endLaunched !== '') {
      Object.assign(queryParams, {endLaunched: search.endLaunched});
    }
    if (search.open) {
      Object.assign(queryParams, {open: search.open});
    }
    if (search.schemaKind && search.schemaKind !== '') {
      Object.assign(queryParams, {schemaKind: search.schemaKind});
    }
    return queryParams;
  }
}
